/*
This component is designed to render the markdown, which is **not** the GitLab Flavored Markdown.

It renders the code snippets the same way GitLab Flavored Markdown code snippets are rendered
respecting the user's preferred color scheme and featuring a copy-code button.

This component can be used to render client-side markdown that doesn't have GitLab-specific markdown elements such as issue links.
*/ import { marked } from 'marked';
import CodeBlockHighlighted from '~/vue_shared/components/code_block_highlighted.vue';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { sanitize } from '~/lib/dompurify';
import { strictMarkdownConfig } from '~/lib/utils/text_utility';
import { __ } from '~/locale';
import SimpleCopyButton from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/simple_copy_button.vue?vue3';
export default {
    name: 'NonGfmMarkdown',
    components: {
        CodeBlockHighlighted,
        SimpleCopyButton
    },
    directives: {
        SafeHtml
    },
    props: {
        markdown: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            hoverMap: {}
        };
    },
    computed: {
        markdownBlocks () {
            // we use lexer https://marked.js.org/using_pro#lexer
            // to get an array of tokens that marked npm module uses.
            // We will use these tokens to override rendering of some of them
            // with our vue components
            const tokens = marked.lexer(this.markdown);
            // since we only want to differentiate between code and non-code blocks
            // we want non-code blocks merged together so that the markdown parser could render
            // them according to the markdown rules.
            // This way we introduce minimum extra wrapper mark-up
            const flattenedTokens = [];
            for (const token of tokens){
                const lastFlattenedToken = flattenedTokens[flattenedTokens.length - 1];
                if (token.type === 'code') {
                    flattenedTokens.push(token);
                } else if (lastFlattenedToken?.type === 'markdown') {
                    lastFlattenedToken.raw += token.raw;
                } else {
                    flattenedTokens.push({
                        type: 'markdown',
                        raw: token.raw
                    });
                }
            }
            return flattenedTokens;
        }
    },
    methods: {
        getSafeHtml (markdown) {
            return sanitize(marked.parse(markdown), strictMarkdownConfig);
        },
        setHoverOn (key) {
            this.hoverMap = {
                ...this.hoverMap,
                [key]: true
            };
        },
        setHoverOff (key) {
            this.hoverMap = {
                ...this.hoverMap,
                [key]: false
            };
        },
        isLastElement (index) {
            return index === this.markdownBlocks.length - 1;
        }
    },
    safeHtmlConfig: {
        ADD_TAGS: [
            'use',
            'gl-emoji',
            'copy-code'
        ]
    },
    i18n: {
        copyCodeTitle: __('Copy code')
    },
    fallbackLanguage: 'text'
};
